const LogoIcon = () => (
  <img
    src="/logo-craftview.png"
    alt="Craftview"
    style={{ height: 28, width: 28, objectFit: 'contain' }}
  />
);

export default LogoIcon;
